import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLHARAMI', label: 'Harami', lookback: 11 })
